export class Point {
  lat: number;
  lon: number;

}
